/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 869417d840c4
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * The type of resource to upload:
 *
 * @remarks
 * - "image" for uploading strictly images
 * - "video" for uploading strictly videos
 * - "raw" for uploading non-media files
 * - "auto" for allowing Cloudinary to automatically detect the type of the uploaded file
 */
export const UploadResourceType = {
  Image: "image",
  Video: "video",
  Raw: "raw",
  Auto: "auto",
} as const;
/**
 * The type of resource to upload:
 *
 * @remarks
 * - "image" for uploading strictly images
 * - "video" for uploading strictly videos
 * - "raw" for uploading non-media files
 * - "auto" for allowing Cloudinary to automatically detect the type of the uploaded file
 */
export type UploadResourceType = ClosedEnum<typeof UploadResourceType>;

export const UploadResourceType$zodSchema = z.enum([
  "image",
  "video",
  "raw",
  "auto",
]).describe(
  "The type of resource to upload:\n- \"image\" for uploading strictly images\n- \"video\" for uploading strictly videos\n- \"raw\" for uploading non-media files\n- \"auto\" for allowing Cloudinary to automatically detect the type of the uploaded file\n",
);
